import { WorkflowType } from '@/app/workflows/actions/constants';
import { Box } from '@mantine/core';
import {
  IconAdjustmentsStar as CustomWorkflowIcon,
  IconAdjustmentsBolt as FactoryWorkflowIcon,
} from '@tabler/icons-react';

export function WorkflowIcon({ type }: { type: WorkflowType }) {
  return (
    <>
      {type === WorkflowType.CUSTOM ? (
        <Box
          style={(theme) => ({
            backgroundColor: theme.colors.violet[0],
            width: '40px',
            height: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '5px',
            padding: '10px',
          })}
        >
          <CustomWorkflowIcon />
        </Box>
      ) : (
        <Box
          style={(theme) => ({
            backgroundColor: theme.colors.teal[0],
            width: '40px',
            height: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '5px',
            padding: '10px',
          })}
        >
          <FactoryWorkflowIcon />
        </Box>
      )}
    </>
  );
}
